import axios from 'axios'

export default {
  addToCart (data) {
    return axios.post('/api/cart/update', { productCodeId: data.productCodeId, quantity: data.quantity })
      .then(response => JSON.parse(atob(response.data)))
  }
}
